import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import invite1 from 'src/assets/img/invite_1.svg';
import invite2 from 'src/assets/img/invite_2.svg';
import { Heading, Paragraph } from '@innovationnorway/cl-react';
import css from './Invite.module.scss';

const Invite: React.FC = () => {
  const { t: tHelpAndSupport } = useTranslation('onboarding');

  return (
    <div className="stack-large">
      <div className={`${css['section']} stack-medium`}>
        <Heading level={2} className={css['heading']}>
          {tHelpAndSupport('commonQuestions.Invite')}
        </Heading>
        <img className="margin-x--auto display--block" alt="" src={invite2} />
        <div className={css['section-header']}>
          <Paragraph data-size="sm" className={css['label']}>
            {tHelpAndSupport('commonQuestions.Invite.Self.Label')}
          </Paragraph>
          <Heading level={3} className={css['heading']}>
            {tHelpAndSupport('commonQuestions.Invite.Self.Header')}
          </Heading>
        </div>
        <Paragraph data-size="sm">{tHelpAndSupport('commonQuestions.Invite.Self.Text1')}</Paragraph>
        <Paragraph data-size="sm">{tHelpAndSupport('commonQuestions.Invite.Self.Text2')}</Paragraph>
        <Paragraph data-size="sm">{tHelpAndSupport('commonQuestions.Invite.Self.Text3')}</Paragraph>
        <Paragraph data-size="sm">
          <Link to={'/entry-link'}>{tHelpAndSupport('commonQuestions.Invite.Self.Link')}</Link>
        </Paragraph>
      </div>
      <div className={`${css['section']} stack-medium`}>
        <img className="margin-x--auto display--block" alt="" src={invite1} />
        <div className={css['section-header']}>
          <Paragraph data-size="sm" className={css['label']}>
            {tHelpAndSupport('commonQuestions.Invite.Others.Label')}
          </Paragraph>
          <Heading level={3} className={css['heading']}>
            {tHelpAndSupport('commonQuestions.Invite.Others.Header')}
          </Heading>
        </div>
        <Paragraph data-size="sm">
          <Trans
            t={tHelpAndSupport}
            i18nKey={'commonQuestions.Invite.Others.Text'}
            components={{
              '1': <Link to={'https://enveiinn.no'}>enveiinn.no</Link>,
            }}
          ></Trans>
        </Paragraph>
      </div>
    </div>
  );
};

export default Invite;
